var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningTriangle = function SvgWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0zm-1.25 7.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.25 17.009 10.27 4.04a1.956 1.956 0 0 1 3.458 0l7.022 12.968c.727 1.343-.225 2.991-1.73 2.991H4.979c-1.504 0-2.456-1.648-1.729-2.991Zm.864.488 7.022-12.969a.978.978 0 0 1 1.728 0l7.022 12.968c.364.672-.112 1.496-.864 1.496H4.978c-.752 0-1.228-.824-.864-1.495",
    clipRule: "evenodd"
  })));
};
export default SvgWarningTriangle;